<template>
  <div class="">
    <div>
      <nav
        class="bg-white font-bold transition-all delay-150"
        :class="[sticky ? 'fixed top-0 w-full z-40 shadow-main' : '']"
      >
        <div class="gridClass">
          <div class="py-2">
            <div class="flex justify-between items-center">
              <div class="">
                <div class="flex justify-between items-center [&>*]:me-12">
                  <div class="flex justify-center items-center me-6">
                    <div class="flex justify-center items-center text-4xl">
                      <NuxtImg
                        sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                        width="1000"
                        height="1000"
                        class="me-1"
                        :class="sticky ? 'w-10' : 'w-16'"
                        format="webp"
                        quality="100"
                        src="/img/icon.webp"
                        alt="navatel.ir"
                      />
                      <h3 class="text-blue-500">نواتل</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <slot />

    <section class="flex flex-col w-full bg-blue-200">
      <div class="gridClass">
        <div
          class="w-full text-xs font-bold flex items-center justify-center my-4"
        >
          <p>
            تمام حقوق مادی و معنوی متعلق به نواتل، تنها سرویس یکپارچه ابری
            (UCaaS) در ایران می باشد.
          </p>
        </div>
      </div>
    </section>

    <LazyHydrate when-idle>
      <SectionModalSuccess />
    </LazyHydrate>
  </div>
</template>

<script setup>
const sticky = ref(false);

const setSticky = () => {
  sticky.value = true;
};
const setNotSticky = () => {
  sticky.value = false;
};
onMounted(() => {
  getNavaChatElement();
  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
      setSticky();
    } else {
      setNotSticky();
    }
  });
});

function getNavaChatElement() {
  const navaChatElement = document.getElementById("nava-chat");
  if (!navaChatElement) {
    getNavaChatElement();
    return;
  }
  navaChatElement.style.display = "none";
  navaChatElement.classList.remove("show-nava-chat");
}

onBeforeRouteLeave((to, from) => {
  const navaChatElement = document.getElementById("nava-chat");
  navaChatElement.style.display = "block";
  navaChatElement.classList.add("show-nava-chat");
});
</script>

<style>
#nava-chat {
  opacity: 0;
}
.show-nava-chat {
  opacity: 1 !important;
}
</style>
